/* Kiwi reward context value. Split from provider to satisfy ESLint react-refresh. */

import { createContext } from "react";
import type { KiwiSkinConfig } from "@/types/kiwiSkin";

export interface KiwiRewardContextValue {
  triggerReward: (skin: KiwiSkinConfig) => void;
}

export const KiwiRewardContext = createContext<KiwiRewardContextValue | null>(null);
